import {
  ENGAGEMENT_COLUMNS,
  ENGAGEMENT_RANGE_COLUMNS,
  FEEDBACK_COLUMNS,
  FEEDBACK_RANGE_COLUMNS,
} from '@/types/filterKeyConst';

export const parseRangeFilter = (
  filterQueryFormats: StructuredFilterQueryFormatT[],
): StructuredFilter | undefined => {
  const structuredFilter: StructuredFilter = {};

  filterQueryFormats.forEach((filterQueryFormat) => {
    const originalColumnKey = filterQueryFormat.columnKey;
    const { min, max } = getMinMaxColumnKey(originalColumnKey);
    const minValue = filterQueryFormat.rangeValues?.min;
    const maxValue = filterQueryFormat.rangeValues?.max;

    if (typeof minValue !== 'undefined') {
      structuredFilter[min] = minValue;
    }
    if (typeof maxValue !== 'undefined') {
      structuredFilter[max] = maxValue;
    }
  });
  return structuredFilter;
};

export const rangeFilterKeyList = [
  ...Object.values(ENGAGEMENT_RANGE_COLUMNS),
  ...Object.values(FEEDBACK_RANGE_COLUMNS),
];

export const getOrigianlColumnFromRangeColumnKey = (
  columnKey: string,
): string => {
  switch (columnKey) {
    case ENGAGEMENT_RANGE_COLUMNS.MIN_COLLECT_COUNT:
    case ENGAGEMENT_RANGE_COLUMNS.MAX_COLLECT_COUNT:
      return ENGAGEMENT_COLUMNS.COLLECT_COUNT;
    case ENGAGEMENT_RANGE_COLUMNS.MIN_COMMENT_COUNT:
    case ENGAGEMENT_RANGE_COLUMNS.MAX_COMMENT_COUNT:
      return ENGAGEMENT_COLUMNS.COMMENT_COUNT;
    case ENGAGEMENT_RANGE_COLUMNS.MIN_LIKE_COUNT:
    case ENGAGEMENT_RANGE_COLUMNS.MAX_LIKE_COUNT:
      return ENGAGEMENT_COLUMNS.LIKE_COUNT;
    case ENGAGEMENT_RANGE_COLUMNS.MIN_SHARE_COUNT:
    case ENGAGEMENT_RANGE_COLUMNS.MAX_SHARE_COUNT:
      return ENGAGEMENT_COLUMNS.SHARE_COUNT;
    case ENGAGEMENT_RANGE_COLUMNS.MIN_SUBSCRIBERS_COUNT:
    case ENGAGEMENT_RANGE_COLUMNS.MAX_SUBSCRIBERS_COUNT:
      return ENGAGEMENT_COLUMNS.SUBSCRIBERS_COUNT;
    case ENGAGEMENT_RANGE_COLUMNS.MIN_VIEW_COUNT:
    case ENGAGEMENT_RANGE_COLUMNS.MAX_VIEW_COUNT:
      return ENGAGEMENT_COLUMNS.VIEW_COUNT;
    case ENGAGEMENT_RANGE_COLUMNS.MIN_VOTES_DOWN_COUNT:
    case ENGAGEMENT_RANGE_COLUMNS.MAX_VOTES_DOWN_COUNT:
      return ENGAGEMENT_COLUMNS.VOTES_DOWN_COUNT;
    case ENGAGEMENT_RANGE_COLUMNS.MIN_VOTES_UP_COUNT:
    case ENGAGEMENT_RANGE_COLUMNS.MAX_VOTES_UP_COUNT:
      return ENGAGEMENT_COLUMNS.VOTES_UP_COUNT;
    case ENGAGEMENT_RANGE_COLUMNS.MIN_RATE:
    case ENGAGEMENT_RANGE_COLUMNS.MAX_RATE:
      return ENGAGEMENT_COLUMNS.ENGAGEMENT_RATE;
    case ENGAGEMENT_RANGE_COLUMNS.MIN_TOTAL_ENGAGEMENT:
    case ENGAGEMENT_RANGE_COLUMNS.MAX_TOTAL_ENGAGEMENT:
      return ENGAGEMENT_COLUMNS.TOTAL_ENGAGEMENT;
    case FEEDBACK_RANGE_COLUMNS.MIN_IMPRESSION:
    case FEEDBACK_RANGE_COLUMNS.MAX_IMPRESSION:
      return FEEDBACK_COLUMNS.IMPRESSION;
    default:
      throw new Error(`Invalid range column key: ${columnKey}`);
  }
};

export const getMinMaxColumnKey = (
  columnKey: string,
): {
  min: string;
  max: string;
} => {
  switch (columnKey) {
    case ENGAGEMENT_COLUMNS.COLLECT_COUNT:
      return {
        min: ENGAGEMENT_RANGE_COLUMNS.MIN_COLLECT_COUNT,
        max: ENGAGEMENT_RANGE_COLUMNS.MAX_COLLECT_COUNT,
      };
    case ENGAGEMENT_COLUMNS.COMMENT_COUNT:
      return {
        min: ENGAGEMENT_RANGE_COLUMNS.MIN_COMMENT_COUNT,
        max: ENGAGEMENT_RANGE_COLUMNS.MAX_COMMENT_COUNT,
      };
    case ENGAGEMENT_COLUMNS.LIKE_COUNT:
      return {
        min: ENGAGEMENT_RANGE_COLUMNS.MIN_LIKE_COUNT,
        max: ENGAGEMENT_RANGE_COLUMNS.MAX_LIKE_COUNT,
      };
    case ENGAGEMENT_COLUMNS.SHARE_COUNT:
      return {
        min: ENGAGEMENT_RANGE_COLUMNS.MIN_SHARE_COUNT,
        max: ENGAGEMENT_RANGE_COLUMNS.MAX_SHARE_COUNT,
      };
    case ENGAGEMENT_COLUMNS.SUBSCRIBERS_COUNT:
      return {
        min: ENGAGEMENT_RANGE_COLUMNS.MIN_SUBSCRIBERS_COUNT,
        max: ENGAGEMENT_RANGE_COLUMNS.MAX_SUBSCRIBERS_COUNT,
      };
    case ENGAGEMENT_COLUMNS.VIEW_COUNT:
      return {
        min: ENGAGEMENT_RANGE_COLUMNS.MIN_VIEW_COUNT,
        max: ENGAGEMENT_RANGE_COLUMNS.MAX_VIEW_COUNT,
      };
    case ENGAGEMENT_COLUMNS.VOTES_DOWN_COUNT:
      return {
        min: ENGAGEMENT_RANGE_COLUMNS.MIN_VOTES_DOWN_COUNT,
        max: ENGAGEMENT_RANGE_COLUMNS.MAX_VOTES_DOWN_COUNT,
      };
    case ENGAGEMENT_COLUMNS.VOTES_UP_COUNT:
      return {
        min: ENGAGEMENT_RANGE_COLUMNS.MIN_VOTES_UP_COUNT,
        max: ENGAGEMENT_RANGE_COLUMNS.MAX_VOTES_UP_COUNT,
      };
    case ENGAGEMENT_COLUMNS.ENGAGEMENT_RATE:
      return {
        min: ENGAGEMENT_RANGE_COLUMNS.MIN_RATE,
        max: ENGAGEMENT_RANGE_COLUMNS.MAX_RATE,
      };
    case ENGAGEMENT_COLUMNS.TOTAL_ENGAGEMENT:
      return {
        min: ENGAGEMENT_RANGE_COLUMNS.MIN_TOTAL_ENGAGEMENT,
        max: ENGAGEMENT_RANGE_COLUMNS.MAX_TOTAL_ENGAGEMENT,
      };
    case FEEDBACK_COLUMNS.IMPRESSION:
      return {
        min: FEEDBACK_RANGE_COLUMNS.MIN_IMPRESSION,
        max: FEEDBACK_RANGE_COLUMNS.MAX_IMPRESSION,
      };
    default:
      throw new Error(`Invalid range column key: ${columnKey}`);
  }
};

export const getPairColumnKey = (minMaxColumnKey: string) => {
  const originalColumnKey =
    getOrigianlColumnFromRangeColumnKey(minMaxColumnKey);
  const minMaxColumnKeys = getMinMaxColumnKey(originalColumnKey);
  return {
    min: minMaxColumnKeys.min,
    max: minMaxColumnKeys.max,
  };
};
